module.exports = __webpack_public_path__ + "img/shoes.4f3a6471.jpeg";